import router from '../router'
import VueCookies from 'vue-cookies'
router.beforeEach((to, from, next) => {
    // console.log(to.meta.requireAuth,to.fullPath,from.fullPath);
    // 需要登录的页面
    if (to.meta.requireAuth) {
        if (VueCookies.isKey('ACCESS_TOKEN')) {
            next()
        } else {
            next({
                path: '/login',
                query: {
                    redirect: to.fullPath
                }
            })
        }
    } else {
        next()
    }
})